import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface CollectionLendCount {
  id: number
  collectionNo: string
  status: SystemCode
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  title: string
  lendTotalCount: number
  lendCount0: number
  lendCount1: number
  lendCount2: number
  lendCount3: number
  lendCount4: number
  lendCount5: number
  canRemove: boolean
  canDelete: boolean
  childCollectionCount: number
  revision: number
}

export const defaultCollectionLendCount = (): CollectionLendCount => ({
  id: 0,
  collectionNo: '',
  status: defaultSystemCode(),
  searchType: defaultSystemCode(),
  displayTitle: '',
  displayAuthor: '',
  title: '',
  lendTotalCount: 0,
  lendCount0: 0,
  lendCount1: 0,
  lendCount2: 0,
  lendCount3: 0,
  lendCount4: 0,
  lendCount5: 0,
  canRemove: false,
  canDelete: false,
  childCollectionCount: 0,
  revision: 0
})

export function CollectionLendCountFromJSON(json: any): CollectionLendCount {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    title: exists(json, 'sort_title') ? json.sort_title : '',
    lendTotalCount: exists(json, 'lend_total_count')
      ? json.lend_total_count
      : 0,
    lendCount0: exists(json, 'lend_count_0') ? json.lend_count_0 : 0,
    lendCount1: exists(json, 'lend_count_1') ? json.lend_count_1 : 0,
    lendCount2: exists(json, 'lend_count_2') ? json.lend_count_2 : 0,
    lendCount3: exists(json, 'lend_count_3') ? json.lend_count_3 : 0,
    lendCount4: exists(json, 'lend_count_4') ? json.lend_count_4 : 0,
    lendCount5: exists(json, 'lend_count_5') ? json.lend_count_5 : 0,
    canRemove: exists(json, 'can_remove') ? json.can_remove : false,
    canDelete: exists(json, 'can_delete') ? json.can_delete : false,
    childCollectionCount: exists(json, 'child_collection_count')
      ? json.child_collection_count
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
